export default {
  username: 'نام کاربر',
  currentPhone: 'شماره فعلی در سامانه',
  newPhone: 'شماره جدید',
  userId: 'شناسه کاربر',
  swapIfExists: 'جابجایی در صورت وجود',
  swapped: 'شماره ها جابجا شد',
  changed: 'شماره کاربر تغییر کرد',
  submit: 'اعمال',
  users: 'کاربران',
  configs: 'تنظیمات',
  adminPanel: 'پیشخوان مدیر',
  systemLogs: 'رخداد‌های‌‌امنیتی',
  hospitalName: 'نام بیمارستان',
  hospitalEmailName: 'نام کاربری بدون @',
  domainWithProtocol: 'دامنه',
  domainSample: 'https://app.rastech.ir',
  emailNameSample: 'city.hospital',
  nameSample: 'هاشمی نژاد تهران',
  password: 'کلمه عبور',
  passwordSample: 'saHo@058239',
  checkAndCreate: 'بررسی و ساخت',
  emptyInput: 'لطفا فیلد های بالا را کامل کنید',
  invalidEmailName: 'خطا در نام کاربری',
  invalidPassword: 'کلمه عبور نا معتبر',
  shortPassword: 'کلمه عبور کوتاه',
  insecurePassword: 'کلمه عبور غیر امن',
  incorrectUrl: 'دامنه اشتباه',
  nemayandeh: 'اطلاعات نماینده',
  nemayandehEmailName: 'نام کاربری نماینده بدون @',
  nemayandehMailNameSample: 'hospital.city',
  nemayandePassword: 'کلمه عبور نماینده',
  hospitalInfo: 'اطلاعات بیمارستان',
  targetAdminToken: 'توکن ادمین سرور مقصد',
  mainServerToken: 'توکن سرور اصلی',
  districst: 'بخش‌های بیمارستان',
  balin: 'بخش‌های بالینی',
  paraclinic: 'بخش‌های پاراکلینیک',
  office: 'واحد‌های داری پشتیبانی',
  templates: 'قالب‌ها',
  testMode: 'اجرای تستی',
  nemyandehOnly: 'فقط نماینده ایجاد شود',
  roleNamesUnique: 'سمت‌های یکتا',
  roleNamesCombined: 'سمت‌های ترکیبی',
  roleNamesCombinedUnique: 'سمت‌های ترکیبی یکتا',
  roleNamesOther: 'سایر سمت‌ها',
  clinic: 'درمانگاه',
  projectRoles: 'سمت‌ها در کمیته‌ها',
  onlyAddTask: 'فقط اضافه کردن لیست وظایف',
  skipCopyTemplate: 'قالب ها کپی نشود',
};
